import { MeetingShare } from "@/schema"
import { useMutation, useQueryClient } from "@tanstack/react-query"

import { useApiContext } from "@/hooks/api/use-api-context"

import { createMeetingShare, revokeMeetingShare } from "./api"

export function useCreateMeetingShare() {
  const getContext = useApiContext()
  const queryClient = useQueryClient()

  return useMutation<
    MeetingShare,
    Error,
    { meetingId: string; email: string; first_name?: string; last_name?: string }
  >({
    mutationFn: async ({ meetingId, email, first_name, last_name }) => {
      const context = await getContext()
      if (!context) throw new Error("No context found")
      return createMeetingShare(context, meetingId, {
        email,
        first_name: first_name?.trim() || undefined,
        last_name: last_name?.trim() || undefined,
      })
    },
    onSuccess: (_data, { meetingId }) => {
      queryClient.invalidateQueries({ queryKey: ["meetingShares", meetingId] })
    },
  })
}

export function useRevokeMeetingShare() {
  const getContext = useApiContext()
  const queryClient = useQueryClient()

  return useMutation<void, Error, { meetingId: string; shareId: string }>({
    mutationFn: async ({ meetingId, shareId }) => {
      const context = await getContext()
      if (!context) throw new Error("No context found")
      return revokeMeetingShare(context, meetingId, shareId)
    },
    onSuccess: (_data, { meetingId }) => {
      queryClient.invalidateQueries({ queryKey: ["meetingShares", meetingId] })
    },
  })
}
